import styled from "styled-components/macro";

export const StyledReviewCards = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const StyledReviewCard = styled.div`
  margin: 15px;
  background: var(--container-color);
  border-radius: 15px;
  width: 150px;
  padding: 10px;
  text-align: center;
  text-transform: uppercase;

  span {
    color: var(--grey-1);
    font-weight: 500;
    letter-spacing: 1px;
    font-size: 16px;
    font-family: "Inter";
  }

  h2 {
    color: var(--primary-cta);
    font-size: 36px !important;
    font-weight: bold;
    margin-top: 5px;
    margin-bottom: 5px !important;
  }
`;

export const StyledKeepersBox = styled.div`
  h3 {
    text-align: center;
    text-transform: uppercase;
    margin-top: -20px;
    color: var(--grey-0);
  }

  background: var(--container-color);

  width: 740px;
  padding: 50px;
  border-radius: 20px;
  max-height: 400px;
  min-height: 200px;
  overflow-y: auto;
`;

export const StyledKeepersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 15px;
`;

export const StyledExitButton = styled.div`
  text-align: center;
  div {
    font-family: "Inter";
    display: inline-block;
    margin-top: 15px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: white;
    border-radius: 30px;
    cursor: pointer;
    padding: 12px 24px;

    background: transparent;
    border: 2px solid var(--primary-cta);
    color: var(--grey-0);

    &:hover {
      background: var(--menu-color-hover);
    }
  }
`;
